
import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Search, Download } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { DateRange } from 'react-day-picker';
import { DateRangeFilterPicker } from '@/components/DateRangeFilterPicker';

interface SalesFilterProps {
  searchTerm: string;
  statusFilter: string;
  dateRange: DateRange | undefined;
  setSearchTerm: (value: string) => void;
  setStatusFilter: (value: string) => void;
  setDateRange: (range: DateRange | undefined) => void;
  onExportCSV: () => void;
  groupBy: 'none' | 'superadmin' | 'instance';
  setGroupBy: (value: 'none' | 'superadmin' | 'instance') => void;
}

const SalesFilter: React.FC<SalesFilterProps> = ({
  searchTerm,
  statusFilter,
  dateRange,
  setSearchTerm,
  setStatusFilter,
  setDateRange,
  onExportCSV,
  groupBy,
  setGroupBy
}) => {
  return (
    <>
      {/* Filter Section */}
      <div className="flex flex-col md:flex-row gap-4 mb-6">
        <div className="relative flex-grow">
          <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-gray-400" />
          <Input
            placeholder="Search by customer, email, order #, or license..."
            className="pl-8"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        
        <Select value={statusFilter} onValueChange={setStatusFilter}>
          <SelectTrigger className="w-[160px]">
            <SelectValue placeholder="Filter by status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Statuses</SelectItem>
            <SelectItem value="paid">Paid</SelectItem>
            <SelectItem value="pending">Pending</SelectItem>
            <SelectItem value="failed">Failed</SelectItem>
          </SelectContent>
        </Select>
        
        <DateRangeFilterPicker
          dateRange={dateRange}
          onChange={(range) => setDateRange(range)}
        />
        
        <Button variant="outline" onClick={onExportCSV}>
          <Download className="h-4 w-4 mr-2" />
          Export
        </Button>
      </div>
      
      {/* Group by controls */}
      <div className="mb-4">
        <Select value={groupBy} onValueChange={(value: any) => setGroupBy(value)}>
          <SelectTrigger className="w-[200px]">
            <SelectValue placeholder="Group by..." />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="none">No Grouping</SelectItem>
            <SelectItem value="superadmin">Group by Super Admin</SelectItem>
            <SelectItem value="instance">Group by Instance</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </>
  );
};

export default SalesFilter;
